import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { inputAnatomy as parts } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  field: {
    borderRadius: 'var(--chakra-radii-base)',
  },
});

const inputTheme = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {
    size: 'sm',
  },
});

export default inputTheme;
